import * as yup from 'yup';

export const createProjectSchema = yup.object().shape({
  projectUsageArea: yup.number().required('Required'),
  projectUsageType: yup.number().required('Required'),
  projectTitle: yup.string().required('Required'),
  projectNumber: yup
    .string()
    .test(
      'len',
      'Project number can be up to 16 characters long',
      function(value){
        if (!value) return false;
        return value.length <= 16
      }
    ),
  description: yup.string().required('Required'),
  location: yup.string().required('Required'),
  state: yup.string(),
  country: yup.string(),
  approximateGrossArea: yup.lazy(() => yup.string().when('approximateGrossAreaKey', (approximateGrossAreaKey, schema)=>{
    return schema.test('re', 'Required', function(value){
      if (approximateGrossAreaKey !== "" && approximateGrossAreaKey !== undefined && approximateGrossAreaKey !== null){
        if (value && /^(\d+(?:[\.\,]\d+)?)$/.test(value)){
          return true
        }else{
          return false;
        }
      }else{
        return true;
      }
    })
   }).nullable()),
  approximateGrossAreaKey: yup.lazy(() => yup.string().when('approximateGrossArea', (approximateGrossArea, schema)=>{
    return schema.test('re', 'Required', function(value){
      if (approximateGrossArea !== "" && approximateGrossArea !== undefined && approximateGrossArea !== null){
        if (value !== "" && value !== undefined && value !== null){
          return value.length > 0;
        }else{
          return false;
        }
      }else{
        return true;
      }
    })
   }).nullable()),
   approximateTotalBudget: yup.lazy(() => yup.string().when('approximateTotalBudgetKey', (approximateTotalBudgetKey, schema)=>{
    return schema.test('re', 'Required', function(value){
      if (approximateTotalBudgetKey !== "" && approximateTotalBudgetKey !== undefined && approximateTotalBudgetKey !== null){
        if (value !== "" && value !== undefined && value !== null && /^(\d+(?:[\.\,]\d+)?)$/.test(value)){
          return true
        }else{
          return false;
        }
      }else{
        return true;
      }
    })
   }).nullable()),
   approximateTotalBudgetKey: yup.lazy(() => yup.string().when('approximateTotalBudget', (approximateTotalBudget, schema)=>{
    return schema.test('re', 'Required', function(value){
      if (approximateTotalBudget !== "" && approximateTotalBudget !== undefined && approximateTotalBudget !== null){
        if (value !== "" && value !== undefined && value !== null){
          return value.length > 0;
        }else{
          return false;
        }
      }else{
        return true;
      }
    })
   }).nullable()),
  endDate: yup.date(),
  confidential: yup.boolean(),
});

export const createCriteriaSchema = yup.object().shape({
  inputField: yup.boolean(),
  inputType: yup.number().when('inputField', {
    is: true,
    then: yup
      .number()
      .required('Must chose value pattern')
      .test('pattern', 'Must chose value pattern', value => {
        return value != 0;
      }),
  }),
  criteriaName: yup.string().required('Required'),
});